var INTEGER_REGEX = /^[+-]?[0-9]+$/;

function integerValidator() {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: false,
    link: function(scope, element, attrs, ngModelCtrl) {
      ngModelCtrl.$parsers.push(function(viewValue) {
        var modelValue;
        var valid;

        if (viewValue === undefined || viewValue === null) {
          modelValue = null;
          valid = true;
        } else {
          modelValue = viewValue.trim();

          if (modelValue.length === 0) {
            modelValue = null;
            valid = true;
          } else if (INTEGER_REGEX.test(modelValue)) {
            modelValue = parseInt(modelValue, 10);
            valid = true;
          } else {
            modelValue = null;
            valid = false;
          }
        }

        ngModelCtrl.$setValidity('integer', valid);

        return modelValue;
      });
    }
  };
}

export default integerValidator;



/** WEBPACK FOOTER **
 ** ./src/app/validators/integer-validator.directive.js
 **/